module.exports = "<div class=\"alert alert-warning\" role=\"alert\"><span class=\"ni ni-info-circle\"></span> <%= message %></div>\n"